import guards from './guards';
import { SubscriptionsIndex, SubscriptionsBilling, SubscriptionsPayment, SubscriptionsTeaser } from '@S';

export default [
    {
        path: '/my-subscriptions',
        name: 'my-subscriptions',
        component: SubscriptionsIndex,
        beforeEnter: guards.mySubscriptions
    },
    {
        path: '/my-subscriptions/billing',
        name: 'my-subscriptions-billing',
        component: SubscriptionsBilling,
        beforeEnter: guards.mySubscriptions
    },
    {
        path: '/my-subscriptions/payment',
        name: 'my-subscriptions-payment',
        component: SubscriptionsPayment,
        beforeEnter: guards.mySubscriptions
    },
    {
        path: '/my-subscriptions/teaser',
        name: 'my-subscriptions-teaser',
        component: SubscriptionsTeaser,
        beforeEnter: guards.mySubscriptions
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/subscriptions.js